export const GetBorrow = (coinId) => `/MarginWallet/GetBorrow?CoinId=${coinId}`;

export const GetBorrowAmountMax = (coinId) =>
  `/MarginWallet/GetBorrowAmountMax?CoinId=${coinId}`;

export const BorrowInsert = "/MarginWallet/BorrowInsert";
